<template>
  <div class="aboutCenter clearfix">
    <h1>雪帝数字音频</h1>
    <div class="main yuanjiao">
      <div class="oneBox">
        <img class="img-thumbnail rounded" src="/static/images/sc_speaker.png">
        <h2>“ONE-STOP” SOLUTIONS FOR THE CUSTOMER</h2>
      </div>
      <div class="row">
        <div class="col-12 col-lg-5">
          <div class="towBox">
            <h4>了解我们</h4>
            <div class="description">
              <p>雪帝数字音频有限公司成立于2008年，是一家专门从事电脑音乐设备，数码乐器，数字音频及相关领域产品推广销售和研制 开发的高新技术企业。</p>
              <p>
                从2000年起，公司逐步成为专业的品牌代理公司，为中国音乐人带来优质的国际品牌，尖端的技术，和最新的理念。为了配合中国市场的需求，公司开发 了兼销售，演示，培训，教育，研发为一体的综合性可持续发展代理销售模式，在业界建立起了一种创新的营销思路。
              </p>
              <p>
                在成立至今的十年间，公司一直以专业音乐家的角度参与到数字化音乐设备市场的发展中。从有选择地代理国际著名专业品牌，到参与众多合作厂家的项 目开发设计，公司一直关注和配合新一代音乐人的需求，为行业的发展提供全新的视角。
              </p>
              <p>
                在未来的日子里，公司会一如既往地关注中国用户的需求，秉承与国际市场的紧密合作，与中国音乐人和音乐爱好者一起，把握先机，赢得挑战，与世界同步!
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 offset-lg-1">
          <div class="towBox">
            <h4>联系我们</h4>
            <div class="description">
              <dl class="row">
                <dt class="col-sm-3">Find us.</dt>
                <dd class="col-sm-9">
                  <p>Unit 806, 8/F, Block E,Shang Ze Da Du Hui 706 Shimen road, Jing kai qu Hefei,China</p>
                  <p>合肥市经开区石门路尚泽大都会E座</p>
                </dd>
                <dt class="col-sm-3">Call us.</dt>
                <dd class="col-sm-9">
                  0551-63750711
                </dd>
                <dt class="col-sm-3">
                  Email us.
                </dt>
                <dd class="col-sm-9">
                  <p>SALES & MARKETING DEPARTMENT</p>
                  <p>销售和市场部</p>
                  <p>denise@xuediaudio.com</p>
                  <p>TECHNICAL DEPARTMENT</p>
                  <p>技术支持</p>
                  <p>yeti@xuediaudio.com</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';

export default {
  name: 'aboutCenter',
  mixins: [generalMix],
  data () {
    return {
      // 导航
      articleArr: [
        {'imgpath':'/static/images/1.jpg',to:'/article/a','title':'接口齐全，稳定好用还能无损内录——ESI 最新便携小声卡 Amber i1 试用与简评','content':'无论您是直播、表演还是录音，声音品质都任何地方与您的移动设备','name':'邓翔'},
        {'imgpath':'/static/images/2.jpg',to:'/article/b','title':'定好用还能无损内录——ESI 小声卡 Amber i1 试用与简评','content':'声音品质都任何地方与您您的移动设备，声音品的移动设备','name':'代苗苗'},
        {'imgpath':'/static/images/4.jpg',to:'/article/c','title':'定好用还能无损内录，定好用还能无损内录！','content':'声音品质都任何地方与您的移动设备，声音品质都任何地方与您的移动设备','name':'邓翔'},
        {'imgpath':'/static/images/5.jpg',to:'/article/d','title':'定好用还能无损内录，定好用还能无损内录？','content':'都任何地方与您的移动设备，声音品质都任何地方与您的','name':'邓翔'},
        {'imgpath':'/static/images/4.jpg',to:'/article/c','title':'网站无损内录，定好用还能无享！','content':'都任何地方与您的移动设备，声音品质都任何地方与您的','name':'邓翔'},
        {'imgpath':'/static/images/p5.jpg',to:'/article/e','title':'无损内录，定好用还能无','content':'都任何地方与您的移动设备都任何地方与您的移动设备，声音品质都任何地方与您的','name':'代苗苗'},
        {'imgpath':'/static/images/1.jpg',to:'/article/f','title':'无损内录，定好用还能无？','content':'都任何地方声音品质都任何地方与您的与您的移动设备，声音品质都任何地方与您的','name':'邓翔'},
        {'imgpath':'/static/images/3.jpg',to:'/article/g','title':'无损内录，定好用还能无损内录？','content':'都任何地方与您的移动设备，声音品质都任何地方与您的','name':'代苗苗'},
        {'imgpath':'/static/images/5.jpg',to:'/article/h','title':'专业网站建设要牢记的几个事项！','content':'都任何地方与您声音品质都任何地方声音品质都任何地方与您的与您的的移动设备，声音品质都任何地方与您的','name':'邓翔'},
        {'imgpath':'/static/images/1.jpg',to:'/article/i','title':'如何搭建一个出色的个人网站','content':'都任何地方与您的移动设备，声音品您的移动设备，声音品您的移动设备，声音品质都任何地方与您的','name':'邓翔'},
        {'imgpath':'/static/images/3.jpg',to:'/article/g','title':'无损内录，定好用还能无损内录？','content':'都任何地方与您的移动设备，声音品质都任何地方与您的','name':'代苗苗'}
      ]
    }
  },
  components:{
  },
  metaInfo: {
    title: '唯存科技官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '唯存科技|合肥网络公司|合肥市唯存科技'
    },
      {
        name: 'description',
        content: '唯存科技是一家以技术为导向的创业型公司，我们致力于通过激发技术与文化的创造力丰富更多人的文化生活'
      }]
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.aboutCenter{
  margin-top: 100px;
  h1{
    color: #FFFFFF;
    margin-bottom: 40px;
    text-align: center;
  }
  .main{
    margin-top: 80px;
    background:#FFFFFF;
    padding:60px 100px;
    color: #000000;
    div.oneBox{
      text-align: center;
      margin-bottom: 80px;
      img{
        margin-bottom:50px;
        height: 200px;
      }
      h2{

      }
    }
    div.towBox{
      h4{
        margin-bottom: 30px;
      }
    }
  }
}
@media (max-width: 767px) {
  .aboutCenter{
    .main{
      padding: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Center.vue